var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 141.31496062992127",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 141.31496l-100.0 0l0 -141.31496z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 141.31496l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m35.33155 17.85105l0 0c0 -8.931185 7.240158 -16.171339 16.17134 -16.171339l0 0c4.288906 0 8.402149 1.7037611 11.43486 4.736475c3.0327148 3.0327148 4.7364807 7.145958 4.7364807 11.434864l0 0c0 8.931183 -7.240158 16.171339 -16.17134 16.171339l0 0c-8.931183 0 -16.17134 -7.240156 -16.17134 -16.171339z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m35.33155 17.85105l0 0c0 -8.931185 7.240158 -16.171339 16.17134 -16.171339l0 0c4.288906 0 8.402149 1.7037611 11.43486 4.736475c3.0327148 3.0327148 4.7364807 7.145958 4.7364807 11.434864l0 0c0 8.931183 -7.240158 16.171339 -16.17134 16.171339l0 0c-8.931183 0 -16.17134 -7.240156 -16.17134 -16.171339z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m23.32553 84.320564l0 0c-2.4962025 -0.67261505 -3.9778233 -3.24234 -3.3092918 -5.7396393l11.153837 -41.66514c0.3210392 -1.1992455 1.1051216 -2.2210617 2.1797523 -2.84066c1.0746307 -0.6195984 2.3517876 -0.7862282 3.5505066 -0.46322632l18.07856 4.8713417c2.4962006 0.67261124 3.9778214 3.2423325 3.3092918 5.7396317l-11.153835 41.665142c-0.6685333 2.4972992 -3.2340584 3.9765015 -5.730259 3.3038864z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m23.32553 84.320564l0 0c-2.4962025 -0.67261505 -3.9778233 -3.24234 -3.3092918 -5.7396393l11.153837 -41.66514c0.3210392 -1.1992455 1.1051216 -2.2210617 2.1797523 -2.84066c1.0746307 -0.6195984 2.3517876 -0.7862282 3.5505066 -0.46322632l18.07856 4.8713417c2.4962006 0.67261124 3.9778214 3.2423325 3.3092918 5.7396317l-11.153835 41.665142c-0.6685333 2.4972992 -3.2340584 3.9765015 -5.730259 3.3038864z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m7.7212353 135.79343l0 0c-1.5778742 -0.4242401 -2.5141807 -2.0475616 -2.0912995 -3.6258087l20.50206 -76.515945c0.20307541 -0.7578964 0.6988354 -1.40382 1.3782215 -1.7956772c0.67938614 -0.39186096 1.4867439 -0.49755096 2.2444668 -0.29382324l11.427631 3.072525c1.5778732 0.4242401 2.5141792 2.0475693 2.091301 3.6258087l-20.502062 76.51595c-0.42288208 1.5782318 -2.0448132 2.513733 -3.6226883 2.0894928z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m7.7212353 135.79343l0 0c-1.5778742 -0.4242401 -2.5141807 -2.0475616 -2.0912995 -3.6258087l20.50206 -76.515945c0.20307541 -0.7578964 0.6988354 -1.40382 1.3782215 -1.7956772c0.67938614 -0.39186096 1.4867439 -0.49755096 2.2444668 -0.29382324l11.427631 3.072525c1.5778732 0.4242401 2.5141792 2.0475693 2.091301 3.6258087l-20.502062 76.51595c-0.42288208 1.5782318 -2.0448132 2.513733 -3.6226883 2.0894928z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m28.299278 55.903427l0 0c-1.423502 0.38269424 -2.2680454 1.8471184 -1.8863373 3.2708855l20.664959 77.08031c0.18330383 0.6837158 0.6306534 1.2664185 1.2436371 1.6199341c0.6129875 0.35351562 1.3413963 0.4488678 2.0249863 0.26509094l10.309608 -2.7716217c1.4235001 -0.38269043 2.2680435 -1.8471222 1.8863373 -3.2708893l-20.664963 -77.08031l0 0c-0.38170624 -1.4237671 -1.8451157 -2.267727 -3.2686195 -1.8850327z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m28.299278 55.903427l0 0c-1.423502 0.38269424 -2.2680454 1.8471184 -1.8863373 3.2708855l20.664959 77.08031c0.18330383 0.6837158 0.6306534 1.2664185 1.2436371 1.6199341c0.6129875 0.35351562 1.3413963 0.4488678 2.0249863 0.26509094l10.309608 -2.7716217c1.4235001 -0.38269043 2.2680435 -1.8471222 1.8863373 -3.2708893l-20.664963 -77.08031l0 0c-0.38170624 -1.4237671 -1.8451157 -2.267727 -3.2686195 -1.8850327z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m58.587963 58.39636l0 0c0 -0.8900528 0.7215309 -1.6115799 1.6115799 -1.6115799l20.241405 0c0.42742157 0 0.8373337 0.16978836 1.1395645 0.4720192c0.3022232 0.30223083 0.47201538 0.71214294 0.47201538 1.1395607l0 6.4461327c0 0.89004517 -0.7215271 1.6115799 -1.6115799 1.6115799l-20.241405 0c-0.890049 0 -1.6115799 -0.7215347 -1.6115799 -1.6115799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m58.587963 58.39636l0 0c0 -0.8900528 0.7215309 -1.6115799 1.6115799 -1.6115799l20.241405 0c0.42742157 0 0.8373337 0.16978836 1.1395645 0.4720192c0.3022232 0.30223083 0.47201538 0.71214294 0.47201538 1.1395607l0 6.4461327c0 0.89004517 -0.7215271 1.6115799 -1.6115799 1.6115799l-20.241405 0c-0.890049 0 -1.6115799 -0.7215347 -1.6115799 -1.6115799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m55.52211 39.4252l0 0c0.8494644 -0.38269043 1.8483353 -0.004306793 2.2310448 0.84515l9.22826 20.482903c0.18378448 0.40792465 0.19799042 0.8721428 0.039497375 1.2905388c-0.15849304 0.41839218 -0.47669983 0.756691 -0.8846283 0.940464l-6.1521683 2.7716255c-0.8494644 0.38269806 -1.8483353 0.004310608 -2.2310448 -0.8451462l-9.22826 -20.482906l0 0c-0.3827095 -0.849453 -0.004333496 -1.8483086 0.8451309 -2.2310028z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m55.52211 39.4252l0 0c0.8494644 -0.38269043 1.8483353 -0.004306793 2.2310448 0.84515l9.22826 20.482903c0.18378448 0.40792465 0.19799042 0.8721428 0.039497375 1.2905388c-0.15849304 0.41839218 -0.47669983 0.756691 -0.8846283 0.940464l-6.1521683 2.7716255c-0.8494644 0.38269806 -1.8483353 0.004310608 -2.2310448 -0.8451462l-9.22826 -20.482906l0 0c-0.3827095 -0.849453 -0.004333496 -1.8483086 0.8451309 -2.2310028z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#783f04",
    d: "m66.77023 136.1468l0 0c-0.33119965 -0.08930969 -0.5276718 -0.4303131 -0.4388275 -0.76164246l27.452538 -102.37756c0.042663574 -0.15911102 0.14676666 -0.2946663 0.2893982 -0.3768463c0.14263153 -0.08218002 0.31211853 -0.10425186 0.47116852 -0.06136322l2.3987274 0.6468468c0.33119965 0.08931351 0.5276718 0.4303131 0.4388275 0.76164246l-27.452538 102.37758c-0.0888443 0.33132935 -0.42935944 0.5275116 -0.7605667 0.4382019z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#783f04",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m66.77023 136.1468l0 0c-0.33119965 -0.08930969 -0.5276718 -0.4303131 -0.4388275 -0.76164246l27.452538 -102.37756c0.042663574 -0.15911102 0.14676666 -0.2946663 0.2893982 -0.3768463c0.14263153 -0.08218002 0.31211853 -0.10425186 0.47116852 -0.06136322l2.3987274 0.6468468c0.33119965 0.08931351 0.5276718 0.4303131 0.4388275 0.76164246l-27.452538 102.37758c-0.0888443 0.33132935 -0.42935944 0.5275116 -0.7605667 0.4382019z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38761d",
    d: "m5.31266 61.051003l0 0c-1.577874 -0.4242401 -2.5145857 -2.047676 -2.0922046 -3.626049l6.919946 -25.858747c0.20283508 -0.7579613 0.69836617 -1.4039478 1.3775816 -1.7958508c0.6792164 -0.39190292 1.4864798 -0.49761772 2.2442017 -0.2938919l11.42763 3.072525c1.5778751 0.4242401 2.5145874 2.047676 2.092205 3.626049l-6.9199467 25.858746c-0.42238045 1.578373 -2.0439072 2.5139847 -3.6217823 2.0897446z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#38761d",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.31266 61.051003l0 0c-1.577874 -0.4242401 -2.5145857 -2.047676 -2.0922046 -3.626049l6.919946 -25.858747c0.20283508 -0.7579613 0.69836617 -1.4039478 1.3775816 -1.7958508c0.6792164 -0.39190292 1.4864798 -0.49761772 2.2442017 -0.2938919l11.42763 3.072525c1.5778751 0.4242401 2.5145874 2.047676 2.092205 3.626049l-6.9199467 25.858746c-0.42238045 1.578373 -2.0439072 2.5139847 -3.6217823 2.0897446z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiker);
export default __webpack_public_path__ + "static/media/hiker.f5625816dc4b20bc9812c547467cba6c.svg";
export { ForwardRef as ReactComponent };